import { useRef } from "react";
import { DownloadIcon, UploadIcon } from "../../../ui/icons";

interface ScheduleHeaderProps {
  readonly onExport: () => void;
  readonly onImport: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ScheduleHeader({ onExport, onImport }: ScheduleHeaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-1">
      <div className="flex items-center gap-2">
        <h1 className="text-lg font-bold text-ink">Emploi du temps</h1>
      </div>
      <div className="flex gap-2 sm:justify-end">
        <button
          type="button"
          onClick={onExport}
          className="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-ink-muted hover:text-ink border border-border/60 rounded-md hover:bg-surface-alt transition-colors"
        >
          <DownloadIcon className="w-3.5 h-3.5" />
          <span>Exporter</span>
        </button>
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-ink-muted hover:text-ink border border-border/60 rounded-md hover:bg-surface-alt transition-colors"
        >
          <UploadIcon className="w-3.5 h-3.5" />
          <span>Importer</span>
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".json"
          onChange={onImport}
          className="hidden"
        />
      </div>
    </div>
  );
}
